import * as elvish from '@didi/elvish-lib-javascript'
import * as XLSX from 'xlsx'
import { LANG_MAP } from '@/plugins/pebble-ui'
import { env } from '@/utils'
import { gtrAuth, gtrAuths } from '@/utils/gtr-auth'
import { request, initRequestParams } from '@/plugins/plugin-request'
import { Omega } from '@/plugins/plugin-init-omega'
import { FORMILY_LANG_MAP } from '../formily/index'
import { IS_SIM, IS_DEV, IS_PRE } from '@/config/constants'
import { getAuthParams } from '@/plugins/plugin-sso-login'
import Iframe from './iframe.vue'
import Lowcode from './lowcode.vue'
import Weblink from './weblink.vue'
const DEV_APPKEY_PREFIX = 'sim060'
const fetchAdapter = config => {
  const { method, uri, isCors, params, ...otherConfig } = config
  return request[method.toLocaleLowerCase()]({
    url: params.api ? params.api : uri,
    params,
    ...otherConfig,
  }).then(res => ({
    data: res,
  }))
}

/** 低码接入的应用key列表 */

/** 1. 购物袋   */
/** 2. 销售任务系统 */
/** 3. 预算管理 */
/** 4. 广告代运营系统 */
/** 5. 油站中台 */
/** 6. 测试应用 */
/** 7. 预留key */
export const LOWCODE_KEYS = [
  '31e43154f620787a162df31b5df7f686',
  '4c75ba24c2b9a5e70c002d752d54419c',
  '28a6e19f2435e85637f2189d27f210eb',
  '4b52e41b889d00a18e11967987173d7b',
  '9b54eb2a66cf0270a27870aa84a1a491',
  '3137cc62f432a335574b51626c690bca', // wby测试
  '39197de90bed36d09a5154c1f991ad4c',
]
export const BASE_SIM_FLAG = 'sim060'
export const APPKEY_PREFIX = (() => {
  let prefix
  if (IS_DEV) {
    prefix = DEV_APPKEY_PREFIX
  } else if (IS_SIM) {
    prefix = window.location.host.replace(/.*(sim\d+).+/, (match, $1) => {
      return $1
    })
  } else if (IS_PRE) {
    prefix = 'pre'
  } else {
    prefix = 'prod'
  }
  return `${prefix}_app_`
})()
export const keyToAppKey = key => {
  return APPKEY_PREFIX + key
}
export const keyToBaseSimAppKey = key => {
  return `sim060_app_${key}`
}
export const APP_KEYS = LOWCODE_KEYS.map(key => {
  return keyToAppKey(key)
})
// 基准环境appkeys
export const BASE_SIM_APP_KEYS = LOWCODE_KEYS.map(key => {
  return keyToBaseSimAppKey(key)
})
/** fuxisdk 需要的环境变量配置 */
export const FUXI_ENV = (() => {
  if (IS_DEV || IS_SIM) {
    return 'sim'
  } else if (IS_PRE) {
    return 'pre'
  } else {
    return 'prod'
  }
})()
/** 低码支持的组件类型 */
export const fuxiComponents = {
  1: Weblink,
  2: Iframe,
  3: Lowcode,
}
export const initFormilyI18n = curLan => {
  // 设置语言
  if (window.DidiPebbleFormilyMaterials) {
    window.DidiPebbleFormilyMaterials?.setValidateLanguage(curLan || env.get('userInfo').locale)
    window.DidiPebbleFormilyMaterials?.registerValidateLocale({
      [curLan]: { ...FORMILY_LANG_MAP[curLan] },
    })
  }
}
export const initPebbleI18n = curLan => {
  if (window.ELEMENT) {
    window.ELEMENT.locale(LANG_MAP[curLan])
  }
}
/** 注入到低码的参数 */
export const getLowcodeConfig = () => {
  const { locale, country, username } = env.get('userInfo')
  const userAuthCountry = env.get('userAuthCountry')
  const { ticket } = getAuthParams()
  return {
    locale,
    scope: {
      CONSTANT: {
        locale,
        country,
        username,
        userAuthCountry,
        ticket,
      },
      UTILS: {
        gtrAuth,
        gtrAuths,
        XLSX,
        Omega,
        elvish,
        gtrRequest: request,
        getGtrFetchParams: initRequestParams(),
      },
    },
    requestHandlersMap: {
      fetch: fetchAdapter,
    },
  }
}
